export default __webpack_public_path__ + "static/media/logo.eec0242d.png";